import { useEffect, useState } from "react";
import { getTenantDocumentByUuid } from "../../../../../services/document";

const descriptionCacheByDocumentUuid = new Map();
const pendingRequestByDocumentUuid = new Map();

function resolveDescriptionFromResponse(response) {
  const body = response?.data?.body ?? response?.body ?? response?.data ?? null;
  const description = body?.description;
  const summaryText = body?.summary?.text;

  if (typeof summaryText === "string" && summaryText.trim()) return summaryText.trim();
  if (typeof description === "string" && description.trim()) return description.trim();
  return null;
}

export const useDocumentDescription = (documentUuid) => {
  const [description, setDescription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!documentUuid) {
      setDescription(null);
      setIsLoading(false);
      return;
    }

    if (descriptionCacheByDocumentUuid.has(documentUuid)) {
      setDescription(descriptionCacheByDocumentUuid.get(documentUuid));
      setIsLoading(false);
      return;
    }

    let isCancelled = false;
    setIsLoading(true);

    let requestPromise = pendingRequestByDocumentUuid.get(documentUuid);
    if (!requestPromise) {
      requestPromise = getTenantDocumentByUuid(documentUuid)
        .then((response) => {
          const resolvedDescription = resolveDescriptionFromResponse(response);
          descriptionCacheByDocumentUuid.set(documentUuid, resolvedDescription);
          return resolvedDescription;
        })
        .catch((error) => {
          console.error("Error fetching tenant document description:", error);
          descriptionCacheByDocumentUuid.set(documentUuid, null);
          return null;
        })
        .finally(() => {
          pendingRequestByDocumentUuid.delete(documentUuid);
        });

      pendingRequestByDocumentUuid.set(documentUuid, requestPromise);
    }

    requestPromise.then((resolvedDescription) => {
      if (isCancelled) return;
      setDescription(resolvedDescription);
      setIsLoading(false);
    });

    return () => {
      isCancelled = true;
    };
  }, [documentUuid]);

  return {
    description,
    isLoading,
  };
};

